import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
interface skillsProps {
  setAllSuggestedSkills: (skills: []) => void;
  selectedSkills: any;
}
function DTOSkillsDetailsModal({
  setAllSuggestedSkills,
  selectedSkills,
}: skillsProps) {
  const { t, i18n } = useTranslation();
  const suggestedSkills: any = [
    {
      id: 1,
      name: t("Analytical Skills"),
    },
    {
      id: 2,
      name: t("Mobile Web Design"),
    },
    {
      id: 3,
      name: t("Usability Testing"),
    },
    {
      id: 4,
      name: t("Graphics"),
    },
    {
      id: 5,
      name: t("Product Management"),
    },
    {
      id: 6,
      name: t("Mobile Application Design"),
    },
  ];

  useEffect(() => {
    if (suggestedSkills.length) {
      setAllSuggestedSkills(suggestedSkills);
    }
  }, []);

  useEffect(() => {
    if (selectedSkills.length > 0) {
      console.log(selectedSkills, "slected skills");
    }
  }, [selectedSkills.length]);
  return <></>;
}
export default DTOSkillsDetailsModal;
